<h3 mat-dialog-title i18n>Send Report</h3>
<mat-dialog-content>
    <app-user-picker placeholder="Select an user" [myControl]="employee"
                     [readonly]="userReadOnly"></app-user-picker>
    <mat-form-field>
        <input matInput [max]="maxDate"
               [matDatepickerFilter]="dateFilter"
               [matDatepicker]="picker" placeholder="Report Date" i18n-placeholder required
               [formControl]="reportDateControl" name="deliveryDate">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
    <button type="submit" mat-button (click)="closeDialog()" i18n>Send report</button>
</mat-dialog-actions>
